// Port of api/fuel/app/classes/controller/api/monty/tags/create.php
import DB from 'offline/db'
import {
	invalid,
	loadOwnedFamily,
	persist,
	sessionUserId,
	tagToArray,
	unauthorised,
	validateTagData
} from './shared'

export default function(params) {
	var userId = sessionUserId(params)
	var data = params.data || {}
	var family = false

	if (!userId) {
		return unauthorised()
	}

	if (data.family) {
		family = loadOwnedFamily(userId, data.family)

		if (!family) {
			return unauthorised()
		}

		data.context = parseInt(family.family_context, 10) || 0
		data.public = parseInt(family.family_public, 10) || 0

		if (parseInt(family.family_style, 10) || 0) {
			data.colour = family.family_colour || ''
			data.fore = family.family_fore || ''
		}
	}

	if (!validateTagData(data)) {
		return invalid()
	}

	DB.run('INSERT INTO tag (user_id, group_id, buddies_id, family_id, tag_context, tag_public, tag_text, tag_fore, tag_colour, tag_attachments) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)', [
		parseInt(userId, 10) || 0,
		0,
		0,
		parseInt(data.family, 10) || 0,
		parseInt(data.context, 10) || 0,
		parseInt(data.public, 10) || 0,
		String(data.text || '').trim(),
		String(data.fore || ''),
		String(data.colour || ''),
		0
	])

	var id = DB.scalar('SELECT last_insert_rowid()')
	var rows = DB.query('SELECT * FROM tag WHERE tag_id = ?', [id])

	return persist(tagToArray(rows[0]))
}
